module.exports = __webpack_public_path__ + "static/img/yian.6bf43c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/yian.png
// module id = ReZP
// module chunks = 1